/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useTranslation } from "react-i18next";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import { useNavigate } from "react-router";
import ROUTE_PATHS from "routePaths";

function ChangePassword() {
  const { t } = useTranslation("pages");
  const navigate = useNavigate();
  /*
  const passwordRequirements = [
    "One special characters",
    "Min 6 characters",
    "One number (2 are recommended)",
    "Change it often",
  ];

  const renderPasswordRequirements = passwordRequirements.map((item, key) => {
    const itemKey = `element-${key}`;

    return (
      <MDBox key={itemKey} component="li" color="text" fontSize="1.25rem" lineHeight={1}>
        <MDTypography variant="button" color="text" fontWeight="regular" verticalAlign="middle">
          {item}
        </MDTypography>
      </MDBox>
    );
  });
  */

  return (
    <Card id="change-password">
      <MDBox p={3}>
        <MDTypography variant="h5">{t("accountSettings.changePassword")}</MDTypography>
      </MDBox>
      <MDBox component="form" pb={3} px={3}>
        <MDBox mb={2}>
          <MDTypography variant="body2" color="text" fontWeight="bold">
            {t("accountSettings.passwordChangeProcess")}
          </MDTypography>
          <MDBox component="ol" m={0} mt={0.5} pl={3}>
            <MDTypography component="li" variant="body2" color="text" lineHeight={1.6}>
              {t("accountSettings.passwordStep1")}
            </MDTypography>
            <MDTypography component="li" variant="body2" color="text" lineHeight={1.6}>
              {t("accountSettings.passwordStep2")}
            </MDTypography>
            <MDTypography component="li" variant="body2" color="text" lineHeight={1.6}>
              {t("accountSettings.passwordStep3")}
            </MDTypography>
            <MDTypography component="li" variant="body2" color="text" lineHeight={1.6}>
              {t("accountSettings.passwordStep4")}
            </MDTypography>
            <MDTypography component="li" variant="body2" color="text" lineHeight={1.6}>
              {t("accountSettings.passwordStep5")}
            </MDTypography>
            <MDTypography component="li" variant="body2" color="text" lineHeight={1.6}>
              {t("accountSettings.passwordStep6")}
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-end" flexWrap="wrap">
          <MDBox ml="auto">
            <MDButton
              variant="gradient"
              color="dark"
              size="small"
              onClick={() => navigate(ROUTE_PATHS.signOut)}
            >
              {t("accountSettings.changePasswordAction")}
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default ChangePassword;
